import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="backdiv">
 <h2 className="main-title">Who We Are</h2>
      <div className="aboutus-container">

       
        <motion.div
          className="aboutus-image"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img className="cover-img"
            src="./abt-us.webp"
            alt="Company"
            loading="lazy"
          />
        </motion.div>

        <motion.div
          className="aboutus-content"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
         

          <p className="main-text">
          Technology should do more than support a business - it should shape its future.
VedAstra was founded with a clear purpose: to help businesses harness technology in ways that create measurable growth, meaningful innovation, and lasting impact.<br/>

As the technology division of SaptVeda, VedAstra delivers intelligent digital solutions that empower businesses to build stronger brands, create seamless customer experiences, and stay ahead in an ever-evolving digital world.<br/>

We don't simply provide IT services. We design digital ecosystems where technology, creativity, strategy, and business intelligence work together to unlock new opportunities.

Every solution we build reflects our commitment to excellence, innovation, and long-term partnerships.
          </p>

          <div className="aboutus-points">
            <div><FaCheckCircle /> 5+ Years of Experience</div>
            <div><FaCheckCircle /> 50+ Successful Projects</div>
            <div><FaCheckCircle /> Global Client Base</div>
            <div><FaCheckCircle /> Expert Development Team</div>
          </div>

        </motion.div>

      </div>

    </section>
  );
};

export default AboutUs;